import React from "react";
import Reminder from "../common/Reminder";
import Sidebar from "./Sidebar";
import { popupWindow } from "../common/utils/Popup";
import { handleModalNoticeOverlay, toggleSidebar} from "../common/utils/common";
import Cookies from "universal-cookie";
import ModalNoticeOverlay from "../common/ModalNoticeOverlay";

class App extends React.Component {
  render() {
    return (
      <div>
        <ModalNoticeOverlay />
        <div
          id="site-wrapper"
          onClick={(event) => handleModalNoticeOverlay(event)}
        >
          <header className="site-header">
            <div className="site-header-container">
              <div className="site-header-row">
                <div className="header-tagline">
                  <a
                    className="site-logo"
                    href="https://www.us-immigration.com/"
                  >
                    <img
                      alt="American Immigration"
                      src="/assets-static/images/logo-en.png"
                      title="American Immigration"
                    />
                  </a>
                </div>
                <div className="m-menu-icon">
                  <button className="menu-icon" onClick={() => toggleSidebar()}>
                    <span className="menu-icon-bar"></span>
                    <span className="menu-icon-bar"></span>
                    <span className="menu-icon-bar"></span>
                  </button>
                </div>

                <div class="user-utility user-utility-padding">
                  <div class="user-auth">
                    <div class="button">
                      <a
                        id="header-signin"
                        href="/registration/logincheck.do?next=/application-center/applicationcenter.do&amp;lang=en"
                        class="btn-header"
                      >
                        My Account
                      </a>
                      <a
                        id="header-signout"
                        style={{ display: "none" }}
                        href="/application-center/signout.do"
                        class="btn-header"
                      >
                        Sign Out
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <nav class="site-nav">
            <div class="site-nav-container">
              <div class="site-nav-row">
                <div class="nav-item">
                  <a href="https://www.us-immigration.com/us-citizenship-and-naturalization-application/">
                    U.S. CITIZENSHIP
                  </a>
                  <div class="menu one-col">
                    <ul>
                      <li class="menu-title">U.S. Citizenship</li>
                      <li>
                        <a href="https://www.us-immigration.com/us-citizenship-and-naturalization-application/">
                          U.S. Citizenship Application <br />
                          <strong>Form N-400</strong>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.us-immigration.com/certificate-of-citizenship-n-600/">
                          Certificate of Citizenship <br />
                          <strong>Form N-600</strong>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.us-immigration.com/replace-certificate-of-citizenship-form-n565/">
                          Replace Certificate of Citizenship <br />
                          <strong>Form N-565</strong>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="nav-item">
                <a href="https://www.us-immigration.com/green-card/"> GREEN CARD </a>
                  <div class="menu one-col">
                    <p class="green-card-menu-title">
                      GREEN CARD
                    </p>
                    <div class="three-cols">
                      <ul>
                        <li class="sub-menu-title">
                          Green Card Renewal and Replacement
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/replace-lost-stolen-green-card-form-I-90/">
                            Green Card Renewal -<br />
                            <strong>Form I-90</strong>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/replace-lost-stolen-green-card-form-I-90/">
                            Green Card Replacement <br />
                            <strong>Form I-90</strong>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/lost-stolen-green-card-Form-i-90/">
                            Lost or Stolen Green Card
                            <br />
                            <strong>Form I-90</strong>
                          </a>
                        </li>
                      </ul>

                      <ul>
                        <br  />
                        <li class="sub-menu-title">Green Card Through Family</li>
                        <li>
                          <a href="https://www.us-immigration.com/Get-Green-Card-Through-Family-Member/">
                            Family Based Green Card
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/Green-Card-Through-Marriage/">
                            Marriage Based Green Card
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/Green-Card-For-Your-Parents/">
                            Green Card for Parents
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/Green-Card-For-Children/">
                            Green Card for Children
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/Green-Card-For-Brothers-or-Sisters/">
                            Green Card for Siblings
                          </a>
                        </li>
                      </ul>

                      <ul>
                        <br  />
                        <li class="sub-menu-title">Green Card - Related Forms</li>
                        <li>
                          <a href="https://www.us-immigration.com/I-130-immigrant-petition-green-card/">
                            Immigrant Petition
                            <br />
                            <strong>Form I-130</strong>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/Adjustment-of-Status-Form-I-485/">
                            Adjustment of Status
                            <br />
                            <strong>Form I-485</strong>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/form-i751-remove-conditions-green-card/">
                            Remove Residence Conditions
                            <br />
                            <strong>Form I-751</strong>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/Form-I-131-Application-Travel-Document/">
                            Advance Parole Document
                            <br />
                            <strong>Form I-131</strong>
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/Form-I-131-Application-Travel-Document/">
                            Re-entry Permit
                            <br />
                            <strong>Form I-131</strong>
                          </a>
                        </li>
                        <li>
                          <a href="https://app.us-immigration.com/green-card-expiration-reminder-service/">
                            Green Card Expiration Service
                          </a>
                        </li>
                        <li>
                          <a href="https://www.us-immigration.com/green-card/">
                            All Green Card Forms
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="nav-item">
                  <a href="https://www.us-immigration.com/us-visas/">
                    U.S. VISAS
                  </a>
                  <div class="menu one-col">
                    <ul>
                      <li class="menu-title">U.S. VISAS</li>
                      <li>
                        <a href="https://www.us-immigration.com/visa-availability-checker/">
                          Visa Availability Checker
                        </a>
                      </li>
                      <li>
                        <a href="https://www.us-immigration.com/k1-fiancee-visa/">
                          K-1 Fiancé(e) Visa
                          <br />
                          <strong>Application</strong>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.us-immigration.com/immigration-forms/">
                          All U.S. Visas Forms
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="nav-item">
                  <a href="https://www.us-immigration.com/">EMPLOYMENT</a>
                  <div class="menu one-col">
                    <ul>
                      <li class="menu-title">Employment</li>
                      <li>
                        <a href="https://www.us-immigration.com/form-i765-employment-authorization/">
                          Employment Authorization Document (EAD)
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="nav-item menu-right">
                  <a href="https://www.us-immigration.com/immigration-forms/">
                    IMMIGRATION FORMS
                  </a>
                  <div class="menu one-col">
                    <ul>
                      <li class="menu-title">Immigration Forms</li>
                      <li>
                        <a href="https://www.us-immigration.com/deferred-action-application-I-821D/">
                          DACA Renewal -<br />
                          <strong>I-821D</strong>
                        </a>
                      </li>
                      <li>
                        <a href="https://www.us-immigration.com/immigration-forms/">
                          All Immigration Forms
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="nav-item">
                  <a href="https://www.us-immigration.com/">USCIS</a>
                  <div class="menu one-col">
                    <ul>
                      <li class="menu-title">USCIS</li>
                      <li>
                        <a href="https://app.us-immigration.com/case-status/">
                          Case Status
                        </a>
                      </li>
                      <li>
                        <a href="https://www.us-immigration.com/infopass/">
                          Infopass
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="nav-item">
                  <a href="https://www.us-immigration.com/us-immigration-news/">
                    Resources
                  </a>
                  <div class="menu one-col">
                    <ul>
                      <li class="menu-title">Resources</li>
                      <li>
                        <a href="https://www.us-immigration.com/blog/">
                          US Immigration Blog
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </nav>

          <div>
            <Reminder
              termsUrl="https://www.us-immigration.com/conditions/"
              privacyUrl="https://www.us-immigration.com/privacy/"
            />
          </div>

          <footer className="site-footer">
            <div className="footer-nav">
              <a
                onClick={() =>
                  popupWindow(
                    "https://www.us-immigration.com/contact/",
                    800,
                    600,
                  )
                }
              >
                Contact
              </a>
              <a
                onClick={() =>
                  popupWindow(
                    "https://www.us-immigration.com/privacy/",
                    800,
                    600,
                  )
                }
              >
                Privacy Policy
              </a>
              <a
                onClick={() =>
                  popupWindow(
                    "https://www.us-immigration.com/conditions/",
                    800,
                    600,
                  )
                }
              >
                Terms of Use{" "}
              </a>
              <a
                onClick={() =>
                  popupWindow(
                    "https://www.us-immigration.com/conditions/#refundPolicy",
                    800,
                    600,
                  )
                }
              >
                Refund Policy
              </a>
              <a
                onClick={() =>
                  popupWindow("https://www.us-immigration.com/blog/", 800, 600)
                }
              >
                Blog
              </a>
              <a
                onClick={() =>
                  popupWindow(
                    "https://www.us-immigration.com/site-map/",
                    800,
                    600,
                  )
                }
              >
                Site map
              </a>
            </div>
            <div className="footer-disclaimer">
              <div className="footer-disclaimer-container">
                <div className="footer-txt">
                  <p>
                    We are not a law firm, and this site and our software are
                    not a substitute for the advice of a lawyer and do not
                    contain or constitute legal advice. We are not affiliated
                    with or sponsored by the United States government or any
                    government agency. This site provides general information on
                    some commonly encountered immigration matters only and was
                    created to allow you to more simply navigate your completion
                    of immigration paperwork using online software. The content
                    on this site should not be relied on to reach conclusions
                    about any person's specific situation. Self-help software
                    and customer support services are provided solely at a
                    user's direction. Customer support is for technical and
                    billing issues only and will not answer legal questions. We
                    do not provide legal advice, opinions, or recommendations
                    about any individual's specific legal rights, remedies,
                    defenses, options, or strategies. We do not make form
                    recommendations or recommend or provide answers to specific
                    questions on forms, and communications between you and us
                    are not protected by any privilege. Purchase prices do not
                    include applicable government agency filing or biometrics
                    fees, if any. The forms that can be completed using our
                    software can be obtained for free from the U.S. Citizenship
                    and Immigration Services (USCIS) as blank forms with written
                    instructions. Automated eligibility quizzes were created
                    using instructions, rules and regulations published by the
                    USCIS and only indicate whether you meet minimum eligibility
                    requirements to apply for the given immigration benefit.
                    Quiz results do not guarantee eligibility or ineligibility
                    as you may or may not be eligible based on reasons not
                    addressed in the quizzes. Your access to and use of this
                    site, including any purchase, is subject to and constitutes
                    your agreement to the website{" "}
                    <a
                      onClick={() =>
                        popupWindow(
                          "https://www.us-immigration.com/privacy/",
                          800,
                          600,
                        )
                      }
                    >
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a
                      onClick={() =>
                        popupWindow(
                          "https://www.us-immigration.com/conditions/",
                          800,
                          600,
                        )
                      }
                    >
                      Terms of Use
                    </a>
                    . Refunds will only be issued if requested within thirty
                    (30) days and before completed application is printed.
                    Exceptions and restrictions may apply; see{" "}
                    <a
                      onClick={() =>
                        popupWindow(
                          "https://www.us-immigration.com/conditions/#refundPolicy",
                          800,
                          600,
                        )
                      }
                    >
                      Refund Policy
                    </a>{" "}
                    for details.
                  </p>
                </div>

                <div className="footer-copyright">
                  <p>
                    Copyright © 1998-{new Date().getFullYear()}. All Rights
                    Reserved.
                  </p>
                </div>
              </div>
            </div>
          </footer>
        </div>
        <span className="back-to-top"></span>
        <Sidebar />
      </div>
    );
  }
}

export default App;
